// ═══════════════════════════════════════════════════════════════════════════
// i18n — copy FR + EN pour la landing.
// Routes :
//   /     → FR
//   /en   → EN
// ═══════════════════════════════════════════════════════════════════════════

export const STRINGS = {
  fr: {
    // Drapeau de la langue VERS laquelle le switch redirige (depuis FR → EN)
    langSwitch: "🇬🇧",
    langSwitchAriaLabel: "Switch to English",
    nav: {
      features: "Fonctionnalités",
      how: "Comment ça marche",
      crews: "Crews",
      cta: "Télécharger",
    },
    hero: {
      badge: "10 000+ potes déjà dispo",
      h1Pre: "Sors plus,",
      h1Mark: "galère",
      h1Post: "moins.",
      sub: "Partage tes dispos, vois qui est chaud, et lance vos sorties en quelques taps. Tes potes, au même endroit.",
      proof: { joinPre: "Rejoins", joinB: "ta bande", rating: "4.8" },
      stickers: [
        { e: "🎮", t: "Ce soir, gaming ?" },
        { e: "✅", t: "4/6 confirmés" },
        { e: "🍷", t: "Apéro vendredi" },
      ],
    },
    store: {
      iosPre: "Télécharger sur",
      iosTitle: "App Store",
      androidPre: "Bientôt sur",
      androidTitle: "Google Play",
    },
    marquee: [
      "Gaming 🎮",
      "Brunch 🥐",
      "Apéro 🍷",
      "Ciné 🎬",
      "Sport ⚽",
      "Sortie 🎉",
    ],
    features: {
      eyebrow: "Pourquoi Dispo",
      h2Pre: "Tu mérites mieux que",
      h2Hl: "47 messages",
      h2Post: "pour voir tes potes.",
      items: [
        {
          t: "Dispos en un tap",
          d: "Dis quand tu es libre. Tes potes voient direct qui est chaud. Fini les 47 messages.",
        },
        {
          t: "Tes crews, vivants",
          d: "Un groupe = une conv qui dure. Gaming, brunch, sport… chaque bande a son fil.",
        },
        {
          t: "Sondages express",
          d: "Plusieurs créneaux ? Tes potes votent, la meilleure date gagne. Zéro débat.",
        },
      ],
    },
    steps: {
      eyebrow: "Comment ça marche",
      h2Pre: "Prêt en",
      h2Hl: "2 minutes",
      h2Post: ".",
      items: [
        { t: "Télécharge", d: "Gratuit sur iOS & Android" },
        { t: "Invite tes potes", d: "En un tap, par lien ou contacts" },
        { t: "Lance une dispo", d: "Activité, date, c'est parti" },
        { t: "Retrouvez-vous", d: "L'app fait le reste ✨" },
      ],
    },
    crews: {
      tag: "Crews",
      h3Pre: "Une bande,",
      h3Mid: "une",
      h3Hl: "conv qui dure",
      h3Post: ".",
      p: "Chaque groupe garde son fil. Les dispos d'un même crew restent au même endroit : tu retrouves vos plans d'il y a 3 mois en un scroll.",
      bullets: [
        "Mêmes potes → même conv, automatiquement",
        "La dispo en cours épinglée en haut",
        "Tout l'historique de vos sorties",
      ],
    },
    finalCta: {
      h2Pre: "Tes potes sont",
      h2Post: "déjà dispo.",
      p: "Télécharge l'app, invite ta bande, arrête de rater des sorties.",
    },
    footer: {
      terms: "Conditions",
      privacy: "Confidentialité",
      contact: "Contact",
      tag: "© 2026 Dispo · Fait avec 💙 à Paris",
    },
    phone: {
      greetHi: "Bonsoir Alex",
      greetBig: "Tes potes t'attendent",
      heroEyebrow: "LANCE LE MOUVEMENT",
      heroTitleL1: "Crée une dispo",
      heroTitleL2: "ou un sondage",
      mineLabel: "MES DISPOS",
      row1Title: "Apéro chez moi",
      row1Sub: "Vendredi · 20h00",
      row2Title: "Squad gaming",
      row2Sub: "Ce soir · 21h00",
      crewLabel: "LE CREW",
      feedTime: "il y a 12 min",
      feedPill: "Dispo",
      feedText: "Apéro chez moi",
      feedCta: "Je suis dispo",
    },
  },
  en: {
    // Drapeau de la langue VERS laquelle le switch redirige (depuis EN → FR)
    langSwitch: "🇫🇷",
    langSwitchAriaLabel: "Passer en français",
    nav: {
      features: "Features",
      how: "How it works",
      crews: "Crews",
      cta: "Download",
    },
    hero: {
      badge: "10,000+ friends already available",
      h1Pre: "Go out more,",
      h1Mark: "hassle",
      h1Post: "less.",
      sub: "Share when you're free, see who's down, and start hangouts in a few taps. Your crew, all in one place.",
      proof: { joinPre: "Join", joinB: "your crew", rating: "4.8" },
      stickers: [
        { e: "🎮", t: "Gaming tonight?" },
        { e: "✅", t: "4/6 confirmed" },
        { e: "🍷", t: "Drinks Friday" },
      ],
    },
    store: {
      iosPre: "Download on the",
      iosTitle: "App Store",
      androidPre: "Coming soon on",
      androidTitle: "Google Play",
    },
    marquee: [
      "Gaming 🎮",
      "Brunch 🥐",
      "Drinks 🍷",
      "Movies 🎬",
      "Sports ⚽",
      "Night out 🎉",
    ],
    features: {
      eyebrow: "Why Dispo",
      h2Pre: "You deserve better than",
      h2Hl: "47 messages",
      h2Post: "to hang out.",
      items: [
        {
          t: "One-tap availabilities",
          d: "Say when you're free. Your friends instantly see who's down. No more endless threads.",
        },
        {
          t: "Crews that stay alive",
          d: "One group = one lasting conversation. Gaming, brunch, sports… every crew has its thread.",
        },
        {
          t: "Quick polls",
          d: "Multiple time slots? Friends vote, the best one wins. Zero debate.",
        },
      ],
    },
    steps: {
      eyebrow: "How it works",
      h2Pre: "Ready in",
      h2Hl: "2 minutes",
      h2Post: ".",
      items: [
        { t: "Download", d: "Free on iOS & Android" },
        { t: "Invite friends", d: "One tap, by link or contacts" },
        { t: "Drop an availability", d: "Activity, date, you're set" },
        { t: "Meet up", d: "The app handles the rest ✨" },
      ],
    },
    crews: {
      tag: "Crews",
      h3Pre: "One crew,",
      h3Mid: "one",
      h3Hl: "conversation that lasts",
      h3Post: ".",
      p: "Each group keeps its own thread. All your crew's hangouts stay in one place: find plans from 3 months ago with a scroll.",
      bullets: [
        "Same friends → same chat, automatically",
        "The current hangout pinned at the top",
        "Your full history together",
      ],
    },
    finalCta: {
      h2Pre: "Your crew is",
      h2Post: "already free.",
      p: "Download the app, invite your friends, stop missing out.",
    },
    footer: {
      terms: "Terms",
      privacy: "Privacy",
      contact: "Contact",
      tag: "© 2026 Dispo · Made with 💙 in Paris",
    },
    phone: {
      greetHi: "Hey Alex",
      greetBig: "Your crew is waiting",
      heroEyebrow: "START SOMETHING",
      heroTitleL1: "Drop a hangout",
      heroTitleL2: "or a poll",
      mineLabel: "MY HANGOUTS",
      row1Title: "Drinks at mine",
      row1Sub: "Friday · 8pm",
      row2Title: "Gaming squad",
      row2Sub: "Tonight · 9pm",
      crewLabel: "THE CREW",
      feedTime: "12 min ago",
      feedPill: "Free",
      feedText: "Drinks at mine",
      feedCta: "I'm in",
    },
  },
};

export function detectLang(pathname = window.location.pathname) {
  return pathname === "/en" || pathname.startsWith("/en/") ? "en" : "fr";
}
